import { computed } from "vue";

const isProduction = computed< boolean >( () => __APP_MODE__ === 'production' );


export function useFeatureFlags() {
    return {
        isProduction
    }
}
